import { ReactNode } from "react";
import { leaderboardPrizeDesktopSplitWidth } from "../../pages/leaderboard";

interface IPreviousLeaderboardRafflePrizeWinProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

const PreviousLeaderboardRafflePrizeWin = ({
  children,
  style,
}: IPreviousLeaderboardRafflePrizeWinProps) => (
  <div className="prizeContainer" style={style}>
    {children}

    <style jsx>{`
      .prizeContainer {
        min-width: 100%;
      }

      @media (min-width: ${leaderboardPrizeDesktopSplitWidth}) {
        .prizeContainer {
          min-width: auto;
          width: 49%;
          max-width: 500px;
        }
      }
    `}</style>
  </div>
);

export default PreviousLeaderboardRafflePrizeWin;
